import React from 'react'

const GallerySection = () => {
    return (
        <div className="px-[4vw] py-[64px] flex gap-[24px] flex-col">
            <div className="flex flex-col gap-[20px] max-lg:items-center">
                <span className="text-[#101828] text-[36px] font-[600] max-sm:text-center">
                    Our Gallery
                </span>
                <span className="text-[#475467] text-[20px] font-[500] max-sm:text-center">
                    Captions for this to reflect what services we provide.
                </span>
            </div>
            <div className="grid grid-cols-4 max-xl:grid-cols-3 max-lg:grid-cols-2 max-sm:grid-cols-1 gap-[24px]">
                <img
                    src="/images/gallery/galleryImage1.png"
                    alt=""
                    className="w-full h-[500px] cursor-pointer object-cover"
                />
                <img
                    src="/images/gallery/galleryImage2.png"
                    alt=""
                    className="w-full h-[500px] cursor-pointer object-cover"
                />
                <img
                    src="/images/gallery/galleryImage3.png"
                    alt=""
                    className="w-full h-[500px] cursor-pointer object-cover"
                />
                <img
                    src="/images/gallery/galleryImage4.png"
                    alt=""
                    className="w-full h-[500px] cursor-pointer object-cover"
                />
                <img
                    src="/images/gallery/galleryImage5.png"
                    alt=""
                    className="w-full h-[500px] cursor-pointer object-cover"
                />
                <img
                    src="/images/gallery/galleryImage6.png"
                    alt=""
                    className="w-full h-[500px] cursor-pointer object-cover"
                />
            </div>
        </div>
    )
}

export default GallerySection